import { put, takeLatest } from 'redux-saga/effects';
import { controlActions } from './slice';
import { settingsActions } from 'reduxStore/settings/slice';
import { Notification } from 'zComponents/atoms';

export function* triggerSync() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		const res = yield superFetch.post(`/controlServer/sync`);
		if (res.statusCode === 200) {
			yield put(settingsActions.loadOrgSettings());
			yield put(controlActions.triggerSyncSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to trigger Control sync.');
		yield put(controlActions.triggerSyncError(error.message));
	}
}

export default function* controlSagas() {
	yield takeLatest(controlActions.triggerSync, triggerSync);
}
